<template>
    <div class="data-table">
        <h4 v-if="title !== ''" style="text-align: center; font-size: 18px; font-weight: 400">{{ title }}</h4>
        <div style="margin: 20px 0px 10px 0px">
            <el-row>
                <el-col :span="12" style="height: 34px">
                    <template v-if="tbToolbar.length > 1">
                        <el-radio-group v-model="toolbarVal" size="small" @change="radioChange">
                            <el-radio-button v-for="(toolbar, key) in tbToolbar" :key="key" :label="toolbar.val">{{ toolbar.name }}</el-radio-button>
                        </el-radio-group>
                    </template>
                </el-col>
                <el-col :span="12" style="text-align: right; height: 34px">
                    <el-button v-if="isDownload && update" v-table-toxls="views" plain :size="'small'" :file-name="fileName ? fileName : lm.title">
                        <svg-icon icon-class="export" />
                        <span v-pageBtn-lbl="'export'">导出</span>
                    </el-button>
                </el-col>
            </el-row>
        </div>
        <div class="teble-div">
            <el-table v-if="!doing" id="views" v-loading="loading" :data="listData" :summary-method="getSummaries" :show-summary="showSummary" :sum-text="sumText" border style="width: 100%" :span-method="spanMethod">
                <el-table-column type="index" :label="$tx('clgl.clxx.index','序号')" width="45" align="center" />
                <el-table-column v-for="(option, optionKey) in listTb" :key="optionKey" :prop="option.prop" :label="option.title" :width="option.width" :align="option.align" :show-overflow-tooltip="true" :formatter="option.formatter">
                    <el-table-column v-for="(child, childKey) in option.child" :key="childKey" :prop="child.prop" :label="child.title" :width="child.width" :align="child.align" :show-overflow-tooltip="true" :formatter="child.formatter" />
                </el-table-column>
            </el-table>
            <div v-else class="empty-table">
                <span style="font-size: 30px"><i class="el-icon-loading" /></span>
                <br />
                <span v-text-lbl="'common.loading'" style="font-size: var(--portalFontSize15)">正在加载...</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
        title: {
            type: String,
            default: function () {
                return ''
            }
        },
        listTb: {
            type: Array,
            default: function () {
                return []
            }
        }, // 列表头数组
        listData: {
            type: Array,
            default: function () {
                return []
            }
        }, // 表格数据
        getSummaries: {
            type: Function,
            default: function () {
                return true
            }
        }, // 自定义合计行
        sumText: {
            type: String,
            default: function () {
                return '合计'
            }
        }, // 合计标题
        showSummary: {
            type: Boolean,
            default: function () {
                return false
            }
        }, // 是否显示合计
        spanMethod: {
            type: Function,
            default: function () {
                return true
            }
        }, //
        tbToolbar: {
            type: Array,
            default: function () {
                return [{ val: '', name: '' }]
            }
        }, // 多表格切换按钮
        tbToolbarClick: {
            type: Function,
            default: function () {
                return true
            }
        }, // 表格切换点击事件
        fileName: {
            type: String,
            default: function () {
                return ''
            }
        }, // 表格导出标题
        isDownload: {
            type: Boolean,
            default: function () {
                return true
            }
        } // 是否导出
    },
    data() {
        return {
            loading: true,
            toolbarVal: this.tbToolbar.length > 1 ? this.tbToolbar[0].val : '',
            lm: this.$route.meta,
            update: true,
            doing: true
        }
    },
    watch: {
        toolbarVal(val) {
            this.update = false
            this.$nextTick(() => {
                this.update = true
            })
        },
        listTb(val) {
            this.doing = false
            setTimeout(() => {
                this.trandClass()
            }, 1000)
        },
        listData(val) {
            this.doing = false
        },
        fileName(val) {
            this.update = false
            this.$nextTick(() => {
                this.update = true
            })
        }
    },
    created() {
        if (this.tbToolbar.length > 1) {
            this.tbToolbar.forEach((item) => {
                if (item.val === this.toolbarVal) {
                    this.fileName = item.name
                }
            })
            this.update = false
            this.$nextTick(() => {
                this.update = true
            })
        }
    },
    mounted() {
        this.loading = false
    },
    methods: {
        trandClass() {
            const table = document.querySelector('.el-table__footer')
            if (table !== null) {
                const trs = table.querySelectorAll('.has-gutter tr')
                if (trs.length > 0) {
                    trs.forEach((tr) => {
                        tr.className = 'el-table__row'
                    })
                }
            }
        },
        radioChange(val) {
            this.doing = true
            if (typeof this.tbToolbarClick === 'function') {
                this.tbToolbarClick(val)
            }
            if (this.tbToolbar.length > 1) {
                this.tbToolbar.forEach((item) => {
                    if (item.val === val) {
                        this.fileName = item.name
                    }
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.data-table {
    // margin-top: 50px;
    .teble-div {
        position: relative;
        .empty-table {
            position: absolute;
            top: 0;
            width: 100%;
            height: 1000%;
            text-align: center;
        }
    }
}
</style>
<style lang="scss">
// .el-table td.is-center,.el-table td :nth-child(1){
//   text-align: right!important;
// }
</style>
